import {useFormik} from 'formik';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import * as Yup from 'yup';

import AppHeaderBar from '../../../../components/AppHeaderBar';
import useGetCalculateLoan from '../../../../services/hookService/getCalculateLoan/useGetCalculateLoan';
import {removeNonNumeric} from '../../../../utilities/helper/numberHelper';
import LoanForm from './loanForm';
import LoanResult from './loanResult';

const LoanPaymentCalculator = () => {
  const navigate = useNavigate();
  const [view, setView] = useState<'form' | 'result'>('form');

  const {mutate, data, isLoading} = useGetCalculateLoan();

  const formik = useFormik({
    initialValues: {
      amount: '',
      total_repayment_time: '',
      repayment_interval: '',
      loan_rate: '',
    },

    validationSchema: Yup.object({
      amount: Yup.string().required('این ورودی اجباری است'),
      total_repayment_time: Yup.string().required('این ورودی اجباری است'),
      repayment_interval: Yup.string().required('این ورودی اجباری است'),
      loan_rate: Yup.string().required('این ورودی اجباری است'),
    }),

    validateOnMount: true,
    onSubmit: async values => {
      const payload = {
        amount: Number(removeNonNumeric(values.amount)),
        total_repayment_time: Number(
          removeNonNumeric(values.total_repayment_time),
        ),
        repayment_interval: Number(removeNonNumeric(values.repayment_interval)),
        loan_rate: Number(removeNonNumeric(values.loan_rate)),
      };

      mutate(payload, {
        onSuccess: () => {
          // reset form fields to initial values
          formik.resetForm();
          setView('result');
        },
      });
    },
  });

  return (
    <>
      <AppHeaderBar
        title="محاسبه گر وام "
        leftIcon="icon-nameClose-remove"
        leftIconHandler={() =>
          view === 'form' ? navigate(-1) : setView('form')
        }
      />
      <section className="w-screen flex flex-col gap-2 h-[92dvh]">
        {view === 'form' && <LoanForm formik={formik} isLoading={isLoading} />}

        {view === 'result' && <LoanResult data={data} setView={setView} />}
      </section>
    </>
  );
};

export default LoanPaymentCalculator;
